//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

import VSwatches from 'vue-swatches';
// Import the styles too, typically in App.vue or main.js
import 'vue-swatches/dist/vue-swatches.css';

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
    props: ['change_token_value', 'default_token_value', 'hosturl', 'company_trainings'],
    data: function data() {
        return {
            project_id: 0,
            projectname: '',
            text_color: '#686868',
            text_border_color: '#686868',
            background_color: "#f8f9fa",
            border_top_color: "#f7f7f7",
            border_bottom_color: "#f7f7f7",
            question_header_size: 'h4',
            question_size: 'h5',
            show_question_answer: true,
            validate_till: 12,
            validate_yellow: 3,
            lock_till_yellow: true,
            training_value: this.default_token_value || 1,
            training_email: true,
            company_training: false,
            questiongroup_count: 0,
            previewDropzoneImage: {
                url: this.hosturl + '/manage/project/uploadfile',
                method: 'POST',
                thumbnailWidth: 300,
                thumbnailHeight: 300,
                maxFiles: 1,
                parallelUploads: 1,
                autoProcessQueue: false,
                addRemoveLinks: true,
                'dictDefaultMessage': 'Legen Sie die Dateien hier ab, um Sie hochzuladen',
                'dictFallbackMessage': 'Ihr Browser unterstützt Drag&Drop Dateiuploads nicht',
                'dictFallbackText': 'Benutzen Sie das Formular um Ihre Dateien hochzuladen',
                'dictFileTooBig': 'Die Datei ist zu groß.',
                'dictInvalidFileType': 'Eine Datei dieses Typs kann nicht hochgeladen werden',
                'dictResponseError': 'Der Server hat ihre Anfrage  abgelehnt',
                'dictCancelUpload': 'Hochladen abbrechen',
                'dictCancelUploadConfirmation': null,
                'dictRemoveFile': 'Datei entfernen',
                'dictMaxFilesExceeded': 'Sie können keine weiteren Dateien mehr hochladen'
            },
            PagedropzoneOptions: {
                url: this.hosturl + '/manage/project/page/import',
                thumbnailWidth: 150,
                method: 'POST',
                parallelUploads: 1,
                autoProcessQueue: false,
                addRemoveLinks: true,
                'dictDefaultMessage': 'Legen Sie die Dateien hier ab, um Sie hochzuladen',
                'dictFallbackMessage': 'Ihr Browser unterstützt Drag&Drop Dateiuploads nicht',
                'dictFallbackText': 'Benutzen Sie das Formular um Ihre Dateien hochzuladen',
                'dictFileTooBig': 'Die Datei ist zu groß.',
                'dictInvalidFileType': 'Eine Datei dieses Typs kann nicht hochgeladen werden',
                'dictResponseError': 'Der Server hat ihre Anfrage  abgelehnt',
                'dictCancelUpload': 'Hochladen abbrechen',
                'dictCancelUploadConfirmation': null,
                'dictRemoveFile': 'Datei entfernen',
                'dictMaxFilesExceeded': 'Sie können keine weiteren Dateien mehr hochladen'
            }
        };
    },
    mounted: function mounted() {},

    components: {
        FormWizard: FormWizard,
        TabContent: TabContent,
        VSwatches: VSwatches,
        vueDropzone: vue2Dropzone
    },
    methods: {
        previewImageSending: function previewImageSending(file, xhr, formData) {
            formData.append('_token', Laravel.csrfToken);
            formData.append('project_id', this.project_id);
            formData.append('page_id', 0);
            formData.append('filecategory_id', 1);
        },
        PageSending: function PageSending(file, xhr, formData) {
            formData.append('_token', Laravel.csrfToken);
            formData.append('project_id', this.project_id);
        },
        onComplete: function onComplete() {
            var _this2 = this;

            var _this = this;
            var project = {
                '_token': Laravel.csrfToken,
                'name': this.projectname,
                'text_border_color': this.text_border_color,
                'text_color': this.text_color,
                'training_value': this.training_value,
                'background_color': this.background_color,
                'border_top_color': this.border_top_color,
                'border_bottom_color': this.border_bottom_color,
                'validate_till': this.validate_till,
                'validate_yellow': this.validate_yellow,
                'lock_till_yellow': this.lock_till_yellow,
                'question_header_size': this.question_header_size,
                'question_size': this.question_size,
                'show_question_answer': this.show_question_answer,
                'training_email': this.training_email,
                'company_training': this.company_training,
                'show_question_result_text': true,
                'contents_list': this.$refs.contentsList.items
            };

            swal.fire({
                title: "Bitte warten",
                text: "Ihre Schulung wird erstellt",

                showConfirmButton: false,
                allowOutsideClick: false
            });

            axios.post(this.hosturl + "/manage/project/save", project).then(function (response) {
                return _this2.project_id = response.data.id;
            }).then(function () {
                axios.post(_this.hosturl + "/manage/project/page/question/import", { 'project_id': _this.project_id, 'number': _this.questiongroup_count }).then(function () {
                    if (_this.$refs.previewImageDropzone.getAcceptedFiles().length === 0) {
                        if (_this.$refs.pageDropzone.getAcceptedFiles().length === 0) {
                            window.location.href = _this.hosturl + "/manage/project/details/" + _this.project_id;
                        }
                    }
                });
            }).then(function (response) {
                return _this2.$refs.previewImageDropzone.processQueue();
            }).then(function (response) {
                return _this2.$refs.pageDropzone.processQueue();
            });
        },
        preview_upload_complete: function preview_upload_complete() {
            if (this.$refs.pageDropzone.getAcceptedFiles().length === 0) {
                window.location.href = this.hosturl + "/manage/project/details/" + this.project_id;
            }
        },

        page_uploaded_complete: function page_uploaded_complete() {
            window.location.href = this.hosturl + "/manage/project/details/" + this.project_id;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/ProjectImport.vue
// module id = 45
// module chunks = 0